import type { UnitSystem } from '@/hooks/useUnitPreferences';

/** Convert meters to kilometers */
export function metersToKm(meters: number): number {
  return meters / 1000;
}

/** Convert meters to miles */
export function metersToMiles(meters: number): number {
  return meters * 0.000621371;
}

/**
 * Format a drive duration in seconds to a human-readable string.
 * Examples: "< 1 min", "45 min", "2h 15min", "10h 0min"
 */
export function formatDriveDuration(seconds: number): string {
  if (seconds < 0) return '--';
  if (seconds < 60) return '< 1 min';

  const totalMinutes = Math.round(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${minutes} min`;
  return `${hours}h ${minutes}min`;
}

/**
 * Format a drive distance in meters to a human-readable string with units.
 * Examples: "14.2 mi", "228 km", "0.5 mi"
 */
export function formatDriveDistance(meters: number, units: UnitSystem): string {
  if (meters < 0) return '--';

  const value = units === 'imperial' ? metersToMiles(meters) : metersToKm(meters);
  const unit = units === 'imperial' ? 'mi' : 'km';

  if (value < 0.1) return `< 0.1 ${unit}`;
  if (value < 100) return `${value.toFixed(1)} ${unit}`;
  return `${Math.round(value)} ${unit}`;
}
